import React from 'react';
import css from './SubscriptionPage.module.css';
import { useIntl } from 'react-intl';
import { H4, Icons } from '../../components';
const CategoriesList = () => {
  const intl = useIntl();

  const categories = [
    { id: 'CategoriesList.Category1', defaultMessage: 'Land & Tree Services' },
    { id: 'CategoriesList.Category2', defaultMessage: 'Event Services & Rentals' },
    { id: 'CategoriesList.Category3', defaultMessage: 'Vehicle & Equipment Repair' },
    { id: 'CategoriesList.Category4', defaultMessage: 'Animal & Farm Care' },
    { id: 'CategoriesList.Category5', defaultMessage: 'Transport & Cleanup' },
    { id: 'CategoriesList.Category6', defaultMessage: 'Outdoor Carpentry' },
  ];

  return (
    <div className={css.categoriesContainer}>
      <div className={css.planHead}>
        <h2>
          {intl.formatMessage({
            id: 'CategoriesList.Heading',
            defaultMessage: 'Support the Land & Outdoor Economy — Get Paid to Help Others',
          })}
        </h2>
      </div>
      <p className={css.categoriesMessage}>
        {intl.formatMessage({
          id: 'CategoriesList.Message',
          defaultMessage:
            'List your service once, get seen by landowners and guests who need what you do.',
        })}
      </p>
      <H4 as="h4" className={css.categoriesTitle}>
        {intl.formatMessage({
          id: 'CategoriesList.Title',
          defaultMessage: 'Available Categories:',
        })}
      </H4>
      <ul className={css.categoriesList}>
        {categories.map((category, index) => (
          <li key={index} className={css.categoryItem}>
            <Icons name="checkListIcon" />
            {intl.formatMessage({ id: category.id, defaultMessage: category.defaultMessage })}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default CategoriesList;
